import * as dateFnsCompat from 'utils/date-fns-compat';

import fp from "lodash/fp";
import React from 'react';
import { Breadcrumb, BreadcrumbItem, Button, Col, Grid, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import { branch, compose, lifecycle, renderComponent, withHandlers, withProps, withStateHandlers } from 'recompose';
import { bindActionCreators } from 'redux';
import { routes } from '../../../../constants';
import { isBusinessAdmin, isBusinessUser, startOfNextCpdPeriod, startOfThisCpdPeriod } from '../../../../services';
import { taskActions } from '../../../../state/modules/task';
import { userTaskHistorySelector } from '../../../../state/modules/task/selectors';
import { currentUserCpdDaysRemaining, currentUserSelector } from '../../../../state/modules/user';
import { DateSelect, Icon, SortableTable } from '../../../components';
import Loading from '../../loading';
import { formatRow } from './partials/populated-completed-tasks';

const columns = [
  {
    name: 'name',
    display: () => 'Title',
    className: () => "name",
    sortable: true
  },
  {
    name: 'cpdCategory',
    display: () => 'CPD Category',
    className: () => "cpdCategory"
  },
  {
    name: 'cpdHours',
    display: () => 'CPD hours',
    className: () => "cpdHours"
  },
  {
    name: 'dueDate',
    display: () => 'Due Date',
    className: () => "dueDate",
    sortable: true
  },
  {
    name: 'viewTask',
    display: () => '',
    className: () => "viewTask"
  }
]

const CompletedTasks = ({
  rows,
  isFetching,
  onDateRangeChange,
  loadMore,
  sortBy,
  filter
}) => (
    <div className='base-layout'>
      <section id='header--profile' key='cpd-activity-header' className='layout--header'>
        <Grid>
          <Row className='sm-gutter'>
            <Col xs={12} md={5}>
              <Breadcrumb>
                <LinkContainer to={routes.app.professionalProfile.root}>
                  <BreadcrumbItem>
                    Professional profile
                  </BreadcrumbItem>
                </LinkContainer>
                <BreadcrumbItem active>
                  Task History
                </BreadcrumbItem>
              </Breadcrumb>
            </Col>
          </Row>
          <Row className='button-gutter'>
            <Col xs={12} md={5}>
              <h1>
                <Icon icon='cpd-activity-large' /> Task History
              </h1>
              <hr />
            </Col>
          </Row>
        </Grid>
      </section>
      <div id='section--cpd-activity' key='cpd-activity-section' className='layout--section'>
        <Grid>
          <Row className='no-gutter sectionHeader'>
            <form>
              <table className='table--date-search'>
                <tbody>
                  <tr>
                    <td>
                      Show task history between
                    </td>
                    <td>
                      <DateSelect date={filter.fromDate} onChange={(date) => onDateRangeChange('fromDate', date)} />
                    </td>
                    <td>
                      and
                    </td>
                    <td>
                      <DateSelect date={filter.toDate} onChange={(date) => onDateRangeChange('toDate', date)} futureYears={1} />
                    </td>
                  </tr>
                </tbody>
              </table>
            </form>
          </Row>
          <SortableTable
            className='table--task-history'
            isFetching={isFetching}
            unclickable={false}
            rows={rows}
            sortBy={sortBy}
            columns={columns} />
          {
            ((rows.length > 0) && (rows.length % 20 === 0)) ?
              <Row className='no-gutter row-slider'>
                <Col xs={12} md={4} mdOffset={4}>
                  <Button
                    className='large full'
                    onClick={loadMore}>
                    Load more task history
                  </Button>
                </Col>
              </Row> :
              null
          }
        </Grid>
      </div>
    </div>
  );

const mapStateToProps = (state) => ({
  user: currentUserSelector(state),
  history: userTaskHistorySelector(state),
  isFetching: state.task.isFetchingHistory,
  cpdDaysRemaining: currentUserCpdDaysRemaining(state),
  allCpdCategorys: state.cpdCategorys.cpdCategorys,
  industryCpdCategory: state.industry.cpdCategorys
})

const mapDispatchToProps = (dispatch) => ({
  getHistory: bindActionCreators(taskActions.task.getHistory, dispatch),
  loadMoreTasks: bindActionCreators(taskActions.task.loadMore, dispatch)
})


export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  branch(
    ({ user }) => !isBusinessAdmin(user) && !isBusinessUser(user),
    renderComponent(Loading)
  ),
  withStateHandlers(
    ({ cpdDaysRemaining }) => ({
      filter: {
        skip: 0,
        fromDate: startOfThisCpdPeriod(cpdDaysRemaining),
        toDate: startOfNextCpdPeriod(cpdDaysRemaining),
        sort: '',
        take: 20
      },
      noMoreToLoad: false
    }),
    {
      onQuerying: () => (filter) => ({
        filter,
        noMoreToLoad: false
      })
    }
  ),
  lifecycle({
    componentDidMount() {
      const {
        getHistory,
        filter
      } = this.props;
      getHistory(filter);
    }
  }),
  withHandlers({
    sortBy: ({ getHistory, filter, onSort, onQuerying }) => (field, sortOrder) => {
      const sortParam = sortOrder ? `${field},${sortOrder}` : undefined;
      const nextFilter = { ...filter, sort: sortParam, skip: 0 };
      onQuerying(nextFilter);
      getHistory(nextFilter);
    },
    loadMore: ({ loadMoreTasks, filter, completedTasks, onQuerying }) => () => {
      const nextFilter = { ...filter, skip: completedTasks.length };
      onQuerying(nextFilter);
      loadMoreTasks(nextFilter);
    },
    onDateRangeChange: ({ getHistory, filter, onQuerying, setDateRange }) => (key, date) => {
      const nextFilter = { ...filter, [key]: key === 'toDate' ? dateFnsCompat.format(dateFnsCompat.endOfDay(date)) : dateFnsCompat.format(date), skip: 0 };
      onQuerying(nextFilter);
      if (nextFilter.fromDate && nextFilter.toDate) {
        getHistory(nextFilter);
      }
    }
  }),
  withProps(
    ({ history, allCpdCategorys, industryCpdCategory }) => ({
      rows: fp.map(
        formatRow(allCpdCategorys, industryCpdCategory)
      )(history)
    })
  )
)(CompletedTasks);



// WEBPACK FOOTER //
// ./src/containers/pages/app/professional-profile/completed-tasks.js